import _ from 'lodash'

export const preprocessUserFormValues = (values, accounts) => {
  const configs = ['isActive', 'isAdmin']

  _.forEach(configs, (v) => {
    values[v] = _.includes(values.configs, v)
  })

  values.companies = _.map(values?.companies, ({ htg, customerId, allDocuments }) =>
    _.pickBy(
      {
        htg,
        customerId,
        name: _.find(accounts[htg], { customerId })?.name,
        allDocuments,
      },
      _.identity
    )
  )
}
